import { render, staticRenderFns } from "./MegaButton.vue?vue&type=template&id=c0ec4b14&scoped=true"
import script from "./MegaButton.vue?vue&type=script&lang=js"
export * from "./MegaButton.vue?vue&type=script&lang=js"
import style0 from "./MegaButton.vue?vue&type=style&index=0&id=c0ec4b14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ec4b14",
  null
  
)

export default component.exports